import Vue from 'vue'
import Vuex from 'vuex';
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import router from './router'
import Breadcrumbs from './components/bread_crumbs'
import { store } from './store';
// import firebase from 'firebase/app';
// import Vue2Filters from 'vue2-filters'
import VueSweetalert2 from 'vue-sweetalert2';
// import VueFormWizard from 'vue-form-wizard';
// import VueTour from 'vue-tour'
import Notifications from 'vue-notification'
// import { Vue2Dragula } from 'vue2-dragula'
import Toasted from 'vue-toasted';
// import SmartTable from 'vuejs-smart-table'
import * as VueGoogleMaps from 'vue2-google-maps'
// import { VueMasonryPlugin } from 'vue-masonry'
import VueFeather from 'vue-feather';

import { Icon } from "leaflet";
delete Icon.Default.prototype._getIconUrl;

// Import Theme scss
import './assets/scss/app.scss';
import axios from "axios";

// MÍO


// config for firebase
// import config from './config.json'

Icon.Default.mergeOptions({
    iconRetinaUrl: require("./assets/images/vue2leaflet/marker-icon.png"),
    iconUrl: require("./assets/images/vue2leaflet/marker-icon.png")
});

Vue.use(VueFeather);

Vue.use(Toasted,{
    iconPack: 'fontawesome'
});
// Vue.use(Vue2Dragula);

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyDYRsARA3mKLv9PV1EqAhDffTzVzGsaPkg',
        libraries: 'places',
    },
})

Vue.use(Notifications)
// Vue.use(Vue2Filters)
Vue.use(VueSweetalert2);
// Vue.use(VueFormWizard)
// Vue.use(VueTour)
Vue.use(BootstrapVue)
// Vue.use(SmartTable)
Vue.use(require('vue-chartist'))
Vue.use(require('vue-moment'));
Vue.component('Breadcrumbs', Breadcrumbs)
// Vue.use(VueMasonryPlugin)

Vue.config.productionTip = false;
// firebase.initializeApp(config.firebase);
//
// export const db = firebase.firestore();
Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        status: '',
        token: localStorage.getItem('token') || '',
        worker : localStorage.getItem('worker') || '',
    },
    mutations: {

    },
    actions: {

    },
    getters : {

    }
});

// DEBUG
// axios.defaults.baseURL = 'http://127.0.0.1:8000';
// PRODUCCIÓN
axios.defaults.baseURL = '';

axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // Return any error which is not due to authentication back to the calling service
        if (error.response.status === 401) {
            localStorage.clear();
            router.push({ name: 'Login' });
            return Promise.reject(error);
        }
        // Logout user if token refresh didn't work or user is disabled
        // if (error.config.url === '/refresh' || error.response.message === 'Account is disabled.') {
        //     localStorage.clear();
        //     router.push({ name: 'login' });
        //     return new Promise((resolve, reject) => {
        //         reject(error);
        //     });
        // }
        //
        // // OBTENEMOS EL NUEVO TOKEN
        // axios.post(Vue.prototype.$apiURL + 'refresh/', {'token': localStorage.getItem('token')})
        //     .then((response) => {
        //         // New request with new token
        //         const config = error.config;
        //         console.log("REFRESCADO:", response['data']['token'] )
        //         localStorage.setItem('token', response['data']['token']);
        //         localStorage.setItem('worker', response['data']['worker']);
        //         return new Promise((resolve, reject) => {
        //             axios.request(config).then(response => {
        //                 resolve(response);
        //             }).catch((error) => {
        //                 reject(error);
        //             })
        //         });
        //     })
        //     .catch((error) => {
        //         console.log(error.response)
        //         localStorage.clear();
        //         router.push({ name: 'Login' });
        //         return new Promise((resolve, reject) => {
        //             reject(error);
        //         })
        //     });
        return Promise.reject(error);
    }
);

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
